// extracted by mini-css-extract-plugin
module.exports = {"v1xx1i5q":"v1xx1i5q","c1i7i5yp":"c1i7i5yp"};